module.exports = __webpack_public_path__ + "static/media/vectorIcon.a389733a.svg";